import { Youtube, Instagram, Facebook, Linkedin } from 'lucide-react'

export interface DropdownItem {
  name: string
  href: string
}

export interface NavLink {
  name: string
  href: string
  children?: DropdownItem[]
}

export const LOGO_URL =
  'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2FMTDLarge%201.png&site=1856&w=191&h=108&user=1516&opt=w3'

export const socialLinks = [
  {
    icon: Youtube,
    href: 'https://www.youtube.com/channel/UCWe8nIgfZn-Lhny4k-Wn3Wg',
    label: 'YouTube',
  },
  {
    icon: Instagram,
    href: 'https://www.instagram.com/medinatactical360/',
    label: 'Instagram',
  },
  {
    icon: Facebook,
    href: 'https://www.facebook.com/TeamAPCUSA/',
    label: 'Facebook',
  },
  {
    icon: Linkedin,
    href: 'https://www.linkedin.com/in/jose-medina-a84845a/',
    label: 'LinkedIn',
  },
]

export const navLinks: NavLink[] = [
  {
    name: 'Law Enforcement',
    href: '/law-enforcement-capabilities',
  },
  {
    name: 'Crisis Planning',
    href: '/crisis-management-planning',
  },
  {
    name: 'Corporate',
    href: '/corporate-critical-incidents-planning',
  },
  {
    name: 'Civilian',
    href: '/civilian-protection',
  },
  {
    name: 'Training',
    href: '/training',
  },
  {
    name: 'Resources',
    href: '/strategic-partners',
    children: [
      {
        name: 'Blog',
        href: '/blog',
      },
    ],
  },
  {
    name: 'About',
    href: '/medina-tactical-dynamics',
    children: [
      {
        name: 'Meet the Founder',
        href: '/meet-the-founder',
      },
    ],
  },
]
